import { useInfiniteQuery, useQueryClient } from "@tanstack/react-query";
import appHomeEntryClient, {
  AppHomeEntrySearchFilters,
} from "../../../api/appHomeEntry";

const PAGE_SIZE = 20;

const useArtistsList = ({
  query,
  filters,
}: {
  query: string;
  filters?: AppHomeEntrySearchFilters;
}) => {
  const queryClient = useQueryClient();

  const {
    data: entries,
    isLoading,
    fetchNextPage,
    hasNextPage,
  } = useInfiniteQuery({
    queryKey: ["app-home-entries", query, filters],
    queryFn: async ({ pageParam }) => {
      const { skip = 0 } = pageParam as { skip?: number };

      const searchInput = {
        query,
        options: {
          skip,
          limit: PAGE_SIZE,
          filters,
        },
      };

      const response =
        await appHomeEntryClient.searchAppHomeEntries(searchInput);
      response.forEach((entry) => {
        queryClient.setQueryData(["app-home-entry", entry.id], entry);
      });
      return response;
    },
    getNextPageParam: (lastPage, allPages) => {
      const currentPage = allPages.flat().length;
      return currentPage < PAGE_SIZE ? undefined : { skip: currentPage };
    },
    initialPageParam: { skip: 0 },
  });

  const entriesData = entries?.pages.flat() || [];

  return {
    entries: entriesData,
    isLoading,
    fetchNextPage,
    hasNextPage,
  };
};

export default useArtistsList;
